import { css } from '@primeuix/styled';

export const style = css`
    .p-checkbox-group {
        display: inline-flex;
    }
`;
